import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2,
  OnInit,
  OnChanges,
  SimpleChanges,
  AfterViewInit,
  AfterViewChecked,
  OnDestroy
} from '@angular/core';
import { NgControl, AbstractControl, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { LanguageService } from '../services/language.service';

@Directive({
  selector: '[formControlName]'
})
export class AsteriskDirective implements OnInit, OnChanges, AfterViewInit, AfterViewChecked, OnDestroy {
  @Input() numberOnly: number;
  @Input() requiredError: string | undefined;
  @Input() minlengthError: string | undefined;
  @Input() maxlengthError: string | undefined;
  @Input() minError: string | undefined;
  @Input() maxError: string | undefined;
  @Input() emailError: string | undefined;
  @Input() emailDomainError: string | undefined;
  @Input() patternError: string | undefined;
  @Input() character: string | undefined;
  @Input() getOnlyNumbers: string | undefined;
  @Input() onlySpecialChar: string | undefined;
  @Input() startSpecialChar: string | undefined;
  @Input() captchaMismatchError: string | undefined;
  @Input() passwordMismatchError: string | undefined;
  @Input() passwordOldNewMatchError: string | undefined;
  @Input() passwordPatternError: string | undefined;
  @Input('formControlName') formControlName: string | undefined;
  blured: boolean = false;
  isTouched: boolean | null | undefined = false;
  @Input() label!: string | undefined;
  private valueChangesSubscription: Subscription | undefined;
  private languageSubscription: Subscription;
  private currentLanguage: string;
  private translations = {
    en: {
      required: '',//{{label}} is required
      minlength: '{{label}} requires min length of {{value}}',
      maxlength: '{{label}} requires max length of {{value}}',
      min: '{{label}} must be at least {{value}}',
      max: '{{label}} must not exceed {{value}}',
      email: 'Invalid email address',
      emailDomain: 'Email domain "{{value}}" is not allowed',
      pattern: '{{label}} is not valid',
      captchaMismatch: 'Entered value is not matching Captcha',
      passwordMismatch: 'Password does not match to new password',
      passwordOldNewMatch:'Old Password and New Password can not be same',
      //passwordPattern: 'Password does not meet the requirements',
      character: '{{label}} should contain only alphabetic characters.',
      getOnlyNumbers: '{{label}} should not contain only numeric values.',
      onlySpecialChar: '{{label}} should not contain only special characters.',
      startSpecialChar: '{{label}} should not begin with a special character.',      
      passwordPattern: 'Password must contains at least 8 to 16 characters, one uppercase letter, one lowercase letter, one special character, one number',
      default: 'Validation failed: {{key}}'
    },
    hi: {
      required: '{{label}} आवश्यक है',
      minlength: '{{label}} की न्यूनतम लंबाई {{value}} होनी चाहिए',
      maxlength: '{{label}} की अधिकतम लंबाई {{value}} होनी चाहिए',
      min: '{{label}} कम से कम {{value}} होना चाहिए',
      max: '{{label}} {{value}} से अधिक नहीं होना चाहिए',
      email: 'अमान्य ईमेल पता',
      emailDomain: 'ईमेल डोमेन "{{value}}" अनुमत नहीं है',
      pattern: '{{label}} मान्य नहीं है',
      captchaMismatch: 'दर्ज मूल्य कैप्चा से मेल नहीं खाता',
      passwordMismatch: 'पासवर्ड नए पासवर्ड से मेल नहीं खाता है',
      passwordOldNewMatch: 'पुराना पासवर्ड और नया पासवर्ड एक समान नहीं हो सकते',
      //passwordPattern: 'पासवर्ड आवश्यकताओं को पूरा नहीं करता है',
      character:'{{label}} केवल वर्णमाला वर्ण होने चाहिए',
      getOnlyNumbers:'{{label}} केवल संख्यात्मक मान नहीं होना चाहिए',
      onlySpecialChar:'{{label}} केवल विशेष वर्ण नहीं होने चाहिए.',
      startSpecialChar:'{{label}} किसी विशेष वर्ण से आरंभ नहीं होना चाहिए',
      passwordPattern: 'पासवर्ड में कम से कम 8 से 16 अक्षर, एक बड़ा अक्षर, एक छोटा अक्षर, एक विशेष अक्षर, एक संख्या होनी चाहिए',
      default: 'सत्यापन विफल: {{key}}'
    },
    mr: {
      required: '{{label}} आवश्यक आहे',
      minlength: '{{label}} साठी किमान {{value}} अंक आवश्यक आहेत',
      maxlength: '{{label}} ची जास्तीत जास्त लांबी {{value}} असणे आवश्यक आहे',
      min: '{{label}} किमान {{value}} असावे',
      max: '{{label}} {{value}} पेक्षा जास्त नसावे',
      email: 'अवैध ई - मेल आयडी',
      emailDomain: 'ईमेल डोमेन "{{value}}" अनुमत नाही',
      pattern: '{{label}} वैध नाही',
      captchaMismatch: 'दर्ज केलेली किंमत कॅप्चाशी जुळत नाही',
      passwordMismatch: 'पासवर्ड नवीन पासवर्डशी जुळत नाही',
      passwordOldNewMatch:'जुना पासवर्ड आणि नवीन पासवर्ड सारखा असू शकत नाही',
      //passwordPattern: 'पासवर्ड आवश्यकता पूर्ण करत नाही',
      character:'{{label}} फक्त अल्फाबेटिक वर्ण असावेत.',
      getOnlyNumbers:'{{label}} फक्त संख्यात्मक मूल्ये नसावीत',
      onlySpecialChar:'{{label}} केवळ विशेष वर्ण नसावेत.',
      startSpecialChar:'{{label}} विशेष वर्णाने सुरुवात करू नये',
      passwordPattern: 'पासवर्डमध्ये किमान 8 ते 16 वर्ण, एक मोठे अक्षर, एक लोअरकेस अक्षर, एक विशेष वर्ण, एक संख्या असणे आवश्यक आहे.',
      default: 'सत्यापन अयशस्वी: {{key}}'
    },
    gu: {
      required: '{{label}} જરૂરી છે',
      minlength: '{{label}} ની લઘુત્તમ લંબાઈ {{value}} હોવી જોઈએ',
      maxlength: '{{label}} ની મહત્તમ લંબાઈ {{value}} હોવી જોઈએ',
      min: '{{label}} ઓછામાં ઓછું {{value}} હોવું જોઈએ',
      max: '{{label}} {{value}} ને વટાવી શકે નહીં',
      email: 'અમાન્ય ઇમેઇલ સરનામું',
      emailDomain: 'ઇમેઇલ ડોમેન "{{value}}" મંજૂર નથી',
      pattern: '{{label}} માન્ય નથી',
      captchaMismatch: 'દાખલ કરેલું મૂલ્ય કૅપ્ચા સાથે મેળ ખાતું નથી',
      passwordMismatch: 'પાસવર્ડ નવો પાસવર્ડ સાથે મેળ ખાતો નથી',
      passwordOldNewMatch: 'જૂનો પાસવર્ડ અને નવો પાસવર્ડ સરખો હોઈ શકે નહીં',
      //passwordPattern: 'પાસવર્ડ જરૂરીયાતો પૂરી કરતો નથી',
      character:'{{label}} માત્ર આલ્ફાબેટીક અક્ષરો હોવા જોઈએ.',
      getOnlyNumbers:'{{label}} માત્ર આંકડાકીય મૂલ્યો ન હોવા જોઈએ',
      onlySpecialChar:'{{label}} માત્ર વિશિષ્ટ અક્ષરો ન હોવા જોઈએ.',
      startSpecialChar:'{{label}} વિશિષ્ટ પાત્ર સાથે શરૂ થવું જોઈએ નહીં',
      passwordPattern: 'પાસવર્ડમાં ઓછામાં ઓછા 8 થી 16 અક્ષરો, એક અપરકેસ અક્ષર, એક લોઅરકેસ અક્ષર, એક વિશેષ અક્ષર, એક નંબર હોવો આવશ્યક છે.',
      default: 'માન્યતા નિષ્ફળ: {{key}}'
    }
  };

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private ngControl: NgControl | null,
    private ls: LanguageService
  ) {
    const readonlyAttribute = this.el.nativeElement.getAttribute('readonly');
    this.renderer.setAttribute(this.el.nativeElement, 'tabindex', (readonlyAttribute !== null) ? '-1' : '0');
  }

  async ngOnInit() {
    this.currentLanguage = this.ls.currentLanguage;
  }

  async ngAfterViewInit(): Promise<void> {
    this.languageSubscription = this.ls.language$.subscribe(language => {
      this.currentLanguage = language;
      setTimeout(() => {
        this.addAsterisk();
      }, 100);
    });
    setTimeout(() => {
      this.subscribeToValueChanges();
    }, 1500);
  }

  ngAfterViewChecked(): void { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['formControlName']) {
      this.addAsterisk();
    }
  }

  @HostListener('blur')
  onBlur() {
    if (this.formControlName && this.ngControl?.control) {
      this.ngControl?.control.markAsTouched();
      this.isTouched = this.ngControl.control?.touched;
      this.addAsterisk();
    }
  }

  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    if (!this.numberOnly) { return; }
    const input = this.el.nativeElement.value;
    const charCode = event.charCode;
    if (input.length >= this.numberOnly) {
      event.preventDefault();
      return;
    }
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  private subscribeToValueChanges() {
    if (this.valueChangesSubscription) {
      this.valueChangesSubscription.unsubscribe();
    }
    if (this.ngControl?.valueChanges) {
      this.valueChangesSubscription = this.ngControl.valueChanges.subscribe((value) => {
        this.isTouched = this.ngControl?.touched;
        this.addAsterisk();
      });
    }
  }

  private addAsterisk() {
    const formGroup = this.el.nativeElement.closest('.form-group, .form-floating');
    if (!formGroup) return;
    const controlElements = formGroup.querySelectorAll('.form-control, .form-select, .form-check-input');
    controlElements?.forEach((element: any) => this.renderer.removeClass(element, 'border-danger'));
    const inputGroupText = formGroup.querySelectorAll('.input-group-text');
    inputGroupText?.forEach((element: any) => {
      this.renderer.removeClass(element, 'border-danger');
      // this.renderer.removeClass(element, 'bg-danger');
      this.renderer.removeClass(element, 'text-white');
      this.renderer.removeClass(element, 'error');
    });

    formGroup.querySelector('.error')?.remove();
    formGroup.querySelector('span.text-danger')?.remove();

    const formLabel = formGroup.querySelector('.form-label');
    const labelText = this.label || formLabel?.textContent.trim() || 'This';
    const control = this.getFormControl();
    const inputRect = this.el.nativeElement.getBoundingClientRect();
    const parentRect = this.el.nativeElement.parentElement.getBoundingClientRect();
    const relativeError = formGroup.querySelectorAll('.relative-error');
    if (formLabel && control) {
      if (this.isControlRequired(control)) {
        const asteriskSpan = this.renderer.createElement('span');
        this.renderer.addClass(asteriskSpan, 'text-danger');
        this.renderer.appendChild(asteriskSpan, this.renderer.createText(' *'));
        this.renderer.appendChild(formLabel, asteriskSpan);
      }
      if (this.isTouched && !control.valid) {
        const errorKey = Object.keys(control.errors || {})[0];
        const errorDetails = errorKey ? this.getErrorDetails(errorKey, control.errors![errorKey], labelText) : '';
        const requiredError = this.renderer.createElement('small');
        this.renderer.addClass(requiredError, 'error');
        this.renderer.addClass(requiredError, 'text-danger');
        formGroup.classList.contains('row') ? this.renderer.addClass(requiredError, 'col-12') : '';
        if (relativeError.length) {
          // this.renderer.removeClass(requiredError, 'position-absolute');
          this.renderer.removeStyle(requiredError, 'top');
          this.renderer.removeStyle(requiredError, 'left');
          this.renderer.addClass(requiredError, 'd-block');
        } else {
          // this.renderer.addClass(requiredError, 'position-absolute');
          this.renderer.setStyle(requiredError, 'top', inputRect.top - parentRect.top + inputRect.height + 'px');
          this.renderer.setStyle(requiredError, 'left', inputRect.left - parentRect.left + 'px');
        }
        requiredError.textContent = errorDetails;
        let parentElement = this.el.nativeElement.parentElement;
        if (parentElement.classList.contains('input-group')) {
          parentElement = parentElement.parentElement;
        }
        this.renderer.appendChild(parentElement, requiredError);
        controlElements?.forEach((element: any) => this.renderer.addClass(element, 'border-danger'));
        inputGroupText?.forEach((element: any) => {
          this.renderer.addClass(element, 'border-danger');
          // this.renderer.addClass(element, 'bg-danger');
          this.renderer.addClass(element, 'text-white');
        });
      }
    }
    if (!formGroup.classList.contains('form-group')) {
      if (this.isTouched && control && !control.valid) {
        const errorKey = Object.keys(control.errors || {})[0];
        const errorDetails = errorKey ? this.getErrorDetails(errorKey, control.errors![errorKey], labelText) : '';
        const requiredError = this.renderer.createElement('small');
        this.renderer.addClass(requiredError, 'error');
        this.renderer.addClass(requiredError, 'text-danger');
        if (relativeError.length) {
          this.renderer.removeClass(requiredError, 'position-absolute');
          this.renderer.addClass(requiredError, 'd-block');
          this.renderer.removeStyle(requiredError, 'top');
          this.renderer.removeStyle(requiredError, 'left');
        } else {
          this.renderer.addClass(requiredError, 'position-absolute');
          this.renderer.setStyle(requiredError, 'top', inputRect.top - parentRect.top + inputRect.height + 'px');
          this.renderer.setStyle(requiredError, 'left', inputRect.left - parentRect.left + 'px');
        }
        requiredError.textContent = errorDetails;
        const smallError = formGroup.querySelectorAll('small.error');
        smallError.forEach((errorElement: any) => {
          errorElement.remove();
        });

        this.renderer.appendChild(formGroup, requiredError);
        controlElements?.forEach((element: any) => this.renderer.addClass(element, 'border-danger'));
        inputGroupText?.forEach((element: any) => {
          this.renderer.addClass(element, 'border-danger');
          // this.renderer.addClass(element, 'bg-danger');
          this.renderer.addClass(element, 'text-white');
        });
      }
    }

    const inputType = this.el.nativeElement.type;
    const isTextInput = ['text', 'email', 'number', 'textarea', 'file', 'password'].includes(inputType as string);
    if (isTextInput) {
      const placeholderValue = this.el.nativeElement.getAttribute('placeholder');
      if(placeholderValue === 'Not Available' || placeholderValue === 'उपलब्ध नाही'){
        return;
      }
      const newPlaceholder = this.getTranslatedLabel(labelText);
      if (!placeholderValue || placeholderValue !== newPlaceholder) {
        const selector = '.form-control, .form-select';
        this.renderer.setAttribute(
          formGroup.querySelector(selector),
          'placeholder',
          newPlaceholder
        );
      }
    }
  }

  private getTranslatedLabel(label: string): string {
    const placeholderTemplates = {
      en: 'Enter {{label}}',
      hi: '{{label}} दर्ज करें',
      mr: '{{label}} प्रविष्ट करा',
      gu: '{{label}} દાખલ કરો'
    };

    const template = placeholderTemplates[this.currentLanguage] || placeholderTemplates.en;
    return template.replace('{{label}}', label);
  }

  private getFormControl(): AbstractControl | null {
    return this.ngControl?.control as FormControl;
  }

  private isControlRequired(control: AbstractControl | null): boolean {
    const validators = control?.validator ? control.validator({} as AbstractControl) : null;
    return validators ? validators['required'] : false;
  }

  private getErrorDetails(key: string, value: any, label: string): string {
    let template = this.translations[this.currentLanguage][key] || this.translations[this.currentLanguage]['default'];
    let formattedValue = value;
    switch (key) {
      case 'required':
        if (this.requiredError) {
          return this.requiredError;
        }
        template = this.translations[this.currentLanguage][key];
        break;
      case 'minlength':
        if (this.minlengthError) {
          return this.minlengthError;
        }
        formattedValue = value.requiredLength;
        template = this.translations[this.currentLanguage][key];
        break;
      case 'maxlength':
        if (this.maxlengthError) {
          return this.maxlengthError;
        }
        formattedValue = value.requiredLength;
        template = this.translations[this.currentLanguage][key];
        break;
      case 'min':
        if (this.minError) {
          return this.minError;
        }
        formattedValue = value.min;
        template = this.translations[this.currentLanguage][key];
        break;
      case 'max':
        if (this.maxError) {
          return this.maxError;
        }
        formattedValue = value.max;
        template = this.translations[this.currentLanguage][key];
        break;
      case 'email':
        if (this.emailError) {
          return this.emailError;
        }
        template = this.translations[this.currentLanguage][key];
        break;
      case 'emailDomain':
        if (this.emailDomainError) {
          return this.emailDomainError;
        }
        formattedValue = value.value;
        template = this.translations[this.currentLanguage][key];
        break;
      case 'pattern':
        if (this.patternError) {
          return this.patternError;
        }
        template = this.translations[this.currentLanguage][key];
        break;
      case 'captchaMismatch':
        if (this.captchaMismatchError) {
          return this.captchaMismatchError;
        }
        template = this.translations[this.currentLanguage][key];
        break;
        case 'character':
          if (this.character) {
            return this.character;
          }
          template = this.translations[this.currentLanguage][key];
          break;
          case 'getOnlyNumbers':
            if (this.getOnlyNumbers) {
              return this.getOnlyNumbers;
            }
            template = this.translations[this.currentLanguage][key];
            break;
            case 'startSpecialChar':
              if (this.startSpecialChar) {
                return this.startSpecialChar;
              }
              template = this.translations[this.currentLanguage][key];
              break;
              case 'onlySpecialChar':
                if (this.onlySpecialChar) {
                  return this.onlySpecialChar;
                }
                template = this.translations[this.currentLanguage][key];
                break;
      case 'passwordMismatch':
        if (this.passwordMismatchError) {
          return this.passwordMismatchError;
        }
        template = this.translations[this.currentLanguage][key];
        break;
        case 'passwordOldNewMatch':
        if (this.passwordOldNewMatchError) {
          return this.passwordOldNewMatchError;
        }
        template = this.translations[this.currentLanguage][key];
        break;
      case 'passwordPattern':
        if (this.passwordPatternError) {
          return this.passwordPatternError;
        }
        template = this.translations[this.currentLanguage][key];
        break;
      default:
        template = this.translations[this.currentLanguage]['default'];
        formattedValue = value;
    }
    return template.replace('{{label}}', label).replace('{{value}}', formattedValue).replace('{{key}}', key);
  }

  ngOnDestroy() {
    if (this.valueChangesSubscription) {
      this.valueChangesSubscription.unsubscribe();
    }
    if (this.languageSubscription) {
      this.languageSubscription.unsubscribe();
    }
  }
}
